module.exports = __webpack_public_path__ + "img/seemore-arrow.9b5dfc58.svg";